module.exports = __webpack_public_path__ + "img/exclamation-mark-green-icon.2af298c6.svg";